import React from "react";
import "../compatible-devices/CompatibleDevices.scss";
import * as PR from "../../prime-modules/index";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SubHeader from "../../components/SubHeader";
import SupportMailsSection from "../../components/SupportMailsSection";
import getAssets from '../../assets/data/brandingAssets.json';
import { useToast } from "../../context/ToastContext";
import ImportantNote from "./ImportantNote";

const CompatibleDevices = () => {
  const { labels, general } = useToast();

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{general.GEN0001} | {labels.LBL0113}</title>
        <title>{`${general.GEN0001} | ${labels.LBL0113}`}</title>
      </Helmet>

      {/* Header Section */}
      <SubHeader header={labels.LBL0113} subText={labels.LBL0114} />

      <section className="about-blocks-section compatible-devices-section">
        <div className="custom-container">
          <p className="text-center mb-6"><span className="font-medium">{labels.LBL0115}:</span> {labels.LBL0116} <span>{labels.LBL0117}</span> {labels.LBL0119}</p>
          <div className="faq-tabs device-tabs">
            <PR.TabView>
              <PR.TabPanel header={labels.LBL0118}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                    <li>iPhone 17 series</li>
                                    <li>iPhone 16 series</li>
                                    <li>iPhone 15 series</li>
                                    <li>iPhone 14 series</li>
                                    <li>iPhone 13 series</li>
                                    <li>iPhone 12 series</li>
                                    <li>iPhone 11 series</li>
                                    <li>iPhone XS</li>
                                    <li>iPhone XS Max</li>
                                    <li>iPhone XR</li>
                                </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                    <li>iPhone SE 3 (2022)</li>
                                    <li>iPhone SE 2 (2020)</li>
                                    <li>iPad Pro 12.9″ (3rd Gen or later)</li>
                                    <li>iPad Pro 11″ (1st Gen or later)</li>
                                    <li>iPad Air (3rd Gen or later)</li>
                                    <li>iPad (7th Gen or later)</li>
                                    <li>iPad mini (5th Gen or later)</li>
                                </ul>
                    </div>
                  </div>
                <ImportantNote ios={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.apple} alt="Apple Devices"/>
                </div>
              </PR.TabPanel>
              <PR.TabPanel header={labels.LBL0120}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                    <li>Samsung Galaxy A56</li>
                                    <li>Samsung Galaxy A55</li>
                                    <li>Samsung Galaxy A54 5G</li>
                                    <li>Samsung Galaxy A36</li>
                                    <li>Samsung Galaxy A35</li>
                                    <li>Samsung Galaxy Fold</li>
                                    <li>Samsung Galaxy Note20</li>
                                    <li>Samsung Galaxy Note20 5G</li>
                                    <li>Samsung Galaxy Note20 Ultra</li>
                                    <li>Samsung Galaxy Note20 Ultra 5G</li>
                                </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                       <ul>
                                    <li>Samsung Galaxy Z Flip</li>
                                    <li>Samsung Galaxy Z Flip 3 5G</li>
                                    <li>Samsung Galaxy Z Flip 3 5G Fold</li>
                                    <li>Samsung Galaxy Z Flip 4</li>
                                    <li>Samsung Galaxy Z Flip 5</li>
                                    <li>Samsung Galaxy Z Flip 5G</li>
                                    <li>Samsung Galaxy Z Fold 2</li>
                                    <li>Samsung Galaxy Z Fold 3 5G</li>
                                    <li>Samsung Galaxy Z Fold 4</li>
                                    <li>Samsung Galaxy Z Fold 5</li>
                                </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                    <li>Samsung Galaxy S25 series</li>
                                    <li>Samsung Galaxy S24 series</li>
                                    <li>Samsung Galaxy S23 series</li>
                                    <li>Samsung Galaxy S22 series (except FE)</li>
                                    <li>Samsung Galaxy S21 series (except FE)</li>
                                    <li>Samsung Galaxy S20 series (except FE)</li>
                                    <li>Samsung Galaxy Xcover7 Pro</li>
                                </ul>
                    </div>
                  </div>
                                        <ImportantNote samsung={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.samsung} alt="Samsung Devices"/>
                </div>
              </PR.TabPanel>
              <PR.TabPanel header={labels.LBL0121}>
                  <div className="device-panel">
                    <div className="grid grid-nogutter">
                      <div className="col-12 lg:col-4 md:col-4">
                        <ul>
                                    <li>Google Pixel 9 series</li>
                                    <li>Google Pixel 8 series</li>
                                    <li>Google Pixel 7 series</li>
                                    <li>Google Pixel 6 series</li>
                                    <li>Google Pixel 5 series</li>
                                    <li>Google Pixel 4 series</li>
                                    <li>Google Pixel Fold</li>
                                </ul>
                      </div>
                    </div>
                    <ImportantNote commonMessage={true} />
                    <div className="line"></div>
                    <PR.Image className="devices-img" src={getAssets.compatible_devices.images.google} alt="Google Devices"/>
                  </div>
              </PR.TabPanel>
              <PR.TabPanel header={labels.LBL0179 || "Motorola"}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                        <li>Motorola G53 5G</li>
                                        <li>Motorola G54 5G</li>
                                        <li>Motorola G55 5G</li>
                                        <li>Motorola Edge 40</li>
                                        <li>Motorola Edge 40 Pro</li>
                                        <li>Motorola Edge 40 Neo</li>
                                        <li>Motorola Edge 2022</li>
                                        <li>Motorola Edge 2023</li>
                                        <li>Motorola Edge+ 2023</li>
                                        <li>Motorola Edge 2024</li>
                                        <li>Motorola Edge 50 Fusion</li>
                                        <li>Motorola Edge 50 Ultra</li>
                                    </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                          <ul>
                                        <li>Motorola Edge 60 Fusion</li>
                                        <li>Motorola Edge 60 Pro</li>
                                        <li>Motorola Edge 60 Stylus</li>
                                        <li>Motorola G56</li>
                                        <li>Motorola G86</li>
                                        <li>Motorola G86 Power</li>
                                        <li>Motorola Moto G34</li>
                                        <li>Motorola Moto G85</li>
                                        <li>Motorola Moto G 2024</li>
                                        <li>Motorola Moto G Power 2024</li>
                                    </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">

                           <ul>
                                        <li>Motorola Moto G Stylus 2024</li>
                                        <li>Motorola Razr</li>
                                        <li>Motorola Razr+</li>
                                        <li>Motorola Razr 5G</li>
                                        <li>Motorola Razr 2019</li>
                                        <li>Motorola Razr 2022</li>
                                        <li>Motorola Razr 40</li>
                                        <li>Motorola Razr 40 Ultra</li>
                                        <li>Motorola Razr 50</li>
                                        <li>Motorola Razr 50 Ultra</li>
                                    </ul>
                              </div>
                  </div>
                  <ImportantNote commonMessage={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.huawei} alt="Huawei & Oppo Devices"/>
                </div>
              </PR.TabPanel>
              <PR.TabPanel header={labels.LBL0180 || "Xiaomi"}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                     <ul>
                                <li>Xiaomi 12T Pro</li>
                                <li>Xiaomi 13</li>
                                <li>Xiaomi 13 Lite</li>
                                <li>Xiaomi 13 Pro</li>
                                <li>Xiaomi 13T</li>
                                <li>Xiaomi 13T Pro</li>
                                <li>Xiaomi 14</li>
                                <li>Xiaomi 14 Pro</li>
                            </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                        <ul>
                                <li>Xiaomi 15</li>
                                <li>Xiaomi 15 Pro</li>
                                <li>Xiaomi 15 Ultra</li>
                                <li>Xiaomi Poco X7</li>
                                <li>Xiaomi Redmi Note 13 Pro</li>
                                <li>Xiaomi Redmi Note 13 Pro+</li>
                                <li>Xiaomi Redmi Note 14 Pro 5G</li>
                            </ul>
                    </div>
                  </div>
                  <ImportantNote commonMessage={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.huawei} alt="Huawei & Oppo Devices"/>
                </div>
              </PR.TabPanel>
               <PR.TabPanel header={labels.LBL0181 || "Oppo"}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                    <ul>
                                <li>Oppo Find N2 Flip</li>
                                <li>Oppo Find N5</li>
                                <li>Oppo Find X3</li>
                                <li>Oppo Find X3 Pro</li>
                                <li>Oppo Find X5</li>
                                <li>Oppo Find X5 Pro</li>
                            </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                      <ul>
                                <li>Oppo Find X8</li>
                                <li>Oppo Find X8 Pro</li>
                                <li>Oppo Reno 13</li>
                                <li>Oppo Reno 13 Pro</li>
                                <li>Oppo Reno 14</li>
                                <li>Oppo Reno 14 Pro</li>
                            </ul>
                    </div>
                  </div>
                  <ImportantNote commonMessage={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.huawei} alt="Huawei & Oppo Devices"/>
                </div>
              </PR.TabPanel>
               <PR.TabPanel header={labels.LBL0182 || "Honor"}>
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                  <ul>
                                <li>Honor 200</li>
                                <li>Honor 200 Pro</li>
                                <li>Honor 400</li>
                                <li>Honor 400 Lite</li>
                                <li>Honor 400 Pro</li>
                                <li>Honor 90</li>
                                <li>Honor Magic V2</li>
                            </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                   <ul>
                                <li>Honor Magic V2 RSR</li>
                                <li>Honor Magic 4 Pro</li>
                                <li>Honor Magic 5 Pro</li>
                                <li>Honor Magic 6 RSR</li>
                                <li>Honor Magic 7 Lite</li>
                                <li>Honor Magic 7 Pro</li>
                                <li>Honor Magic 6 RSR</li>
                            </ul>
                    </div>
                  </div>
                  <ImportantNote commonMessage={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.huawei} alt="Huawei & Oppo Devices"/>
                </div>
              </PR.TabPanel>
              <PR.TabPanel header={labels.LBL0123} className="last-tab">
                <div className="device-panel">
                  <div className="grid grid-nogutter">
                    <div className="col-12 lg:col-4 md:col-4">
                         <ul>
                                    <li>Fairphone 4</li>
                                    <li>Fairphone 5</li>
                                    <li>Gemini PDA</li>
                                    <li>Huawei P40</li>
                                    <li>Huawei P40 5G</li>
                                    <li>Huawei P40 Pro</li>
                                    <li>Huawei Mate 40 Pro</li>
                                    <li>Huawei Pura 70 Pro</li>
                                    <li>Nokia G60 5G</li>
                                    <li>Nokia X30 5G</li>
                                    <li>Nokia XR21</li>
                                    <li>Nuu X5</li>
                                    <li>JCB Toughphone E10</li>
                                    <li>OnePlus 11</li>
                                </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                     <ul>
                                    <li>OnePlus 12</li>
                                    <li>OnePlus Open</li>
                                    <li>Oukitel WP30 Pro</li>
                                    <li>Oukitel WP33 Pro</li>
                                    <li>Rakuten Mini</li>
                                    <li>Rakuten Big S</li>
                                    <li>Rakuten Big</li>
                                    <li>Sharp AQUOS wish</li>
                                    <li>Sharp AQUOS zero 6</li>
                                    <li>Sharp AQUOS sense8</li>
                                    <li>Sharp AQUOS R8s</li>
                                    <li>Sharp AQUOS R8s pro</li>
                                    <li>Sony Xperia 10 III Lite</li>
                                </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                      <ul>
                                    <li>Sony Xperia 1 IV</li>
                                    <li>Sony Xperia 1 VI</li>
                                    <li>Sony Xperia 1 VII</li>
                                    <li>Sony Xperia 5 IV</li>
                                    <li>Sony Xperia 5 V</li>
                                    <li>Sony Xperia 10 IV</li>
                                    <li>Sony Xperia 10 V</li>
                                    <li>Sony Xperia 10 VI</li>
                                    <li>Sony Xperia 1 V</li>
                                    <li>Surface Duo</li>
                                    <li>vivo V29</li>
                                    <li>vivo V40</li>
                                    <li>vivo X100 Pro</li>
                                </ul>
                    </div>
                  </div>
                  <h2 className="mt-3">{labels.LBL0124}</h2>
                  <div className="grid grid-nogutter mb-3">
                    <div className="col-12 lg:col-4 md:col-4">
                        <ul>
                          <li>Microsoft Surface Pro X</li>
                          <li>Microsoft Surface Go 2</li>
                          <li>Microsoft Surface Pro LTE Advanced</li>
                          <li>Acer Swift 3</li>
                          <li>Acer Swift 7</li>
                          <li>Asus Mini Transformer</li>
                        </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                      <ul>
                        <li>Asus NovaGo</li>
                        <li>Asus VivoBook Flip 14</li>
                        <li>HP Elitebook G5</li>
                        <li>HP Probook G5</li>
                        <li>HP Zbook G5</li>
                      </ul>
                    </div>
                    <div className="col-12 lg:col-4 md:col-4">
                      <ul>
                        <li>HP Specter Folio 13</li>
                        <li>Lenovo Yoga C630</li>
                        <li>Lenovo Miix 630</li>
                        <li>Lenovo Yoga 520</li>
                        <li>Samsung Galaxy Book 2</li>
                      </ul>
                    </div>
                  </div>
                           <ImportantNote commonMessage={true} />
                  <div className="line"></div>
                  <PR.Image className="devices-img" src={getAssets.compatible_devices.images.other} alt="Other Devices"/>
                </div>
              </PR.TabPanel>
            </PR.TabView>
          </div>
        </div>
      </section>

      <section className="inner-header-section aboutus-header-section support-section">
        <SupportMailsSection/>
      </section>
    </HelmetProvider>
  );
};

export default CompatibleDevices;